/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountSigningKey.defs'
export { main as default } from './updateAccountSigningKey.defs'
